import "./Copy.scss";
import { define } from "@shared/Lib/registry";
import type { Component } from "@shared/Lib/types";

export class Copy implements Component {
  readonly el: HTMLElement;

  private readonly mm = gsap.matchMedia();

  constructor(el: HTMLElement) {
    this.el = el;
    this.init();
  }

  private init(): void {}

  destroy(): void {
    this.mm.revert();
  }
}

define("Copy", (el) => new Copy(el));
